import { useState } from 'react'

export const usePreviewMergeDrawers = ({ fetchReview, sourceId, targetId, jobMappings }) => {
  const [isMapDrawerOpen, setIsMapDrawerOpen] = useState(false)
  const [isDetailsDrawerOpen, setIsDetailsDrawerOpen] = useState(false)
  const [selectedJobs, setSelectedJobs] = useState(null)
  const [selectedTargetJobId, setSelectedTargetJobId] = useState(null)

  const handleEditMapping = (sourceJobIds, targetJobId) => {
    setSelectedJobs({ sourceJobIds, targetJobId })
    setIsMapDrawerOpen(true)
  }

  const handleCloseMapDrawer = () => {
    setIsMapDrawerOpen(false)
    setSelectedJobs(null)
  }

  const handleMappingSaved = () => {
    // Fetch updated review data immediately
    // React Query will handle deduplication if called multiple times
    fetchReview({ sourceId, targetId, jobMappings })
  }

  const handleViewDetails = targetJobId => {
    setSelectedTargetJobId(targetJobId)
    setIsDetailsDrawerOpen(true)
  }

  const handleCloseDetailsDrawer = () => {
    setIsDetailsDrawerOpen(false)
    setSelectedTargetJobId(null)
  }

  return {
    isMapDrawerOpen,
    isDetailsDrawerOpen,
    selectedJobs,
    selectedTargetJobId,
    handleEditMapping,
    handleCloseMapDrawer,
    handleMappingSaved,
    handleViewDetails,
    handleCloseDetailsDrawer,
  }
}
